import { render, staticRenderFns } from "./Synonyms.vue?vue&type=template&id=fd84ddea&scoped=true&"
import script from "./Synonyms.vue?vue&type=script&lang=js&"
export * from "./Synonyms.vue?vue&type=script&lang=js&"
import style0 from "./Synonyms.vue?vue&type=style&index=0&id=fd84ddea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd84ddea",
  null
  
)

export default component.exports